import type { IGlobalState } from '@src/reducers';

export const selectFullDealCalculator = (state: IGlobalState) => state.fullDeal.calculator;
export const selectFullDealCalculatorFeatures = (state: IGlobalState) => state.fullDeal.features;
